import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { ContactSelectProps, ContactsSelect, Text } from '@pletly/ui';
import {
	useOrganisationInfo,
	OrganisationRole,
	OrganisationTeamRole,
} from '@pletly/feature-organisation';

import { useGetOrganisationTeamsQuery } from './__generated__/teams.generated';

type Props = Pick<ContactSelectProps, 'selectedIds' | 'setSelectedIds'> & {
	managedOnly?: boolean;
};

export const TeamSelect = ({ selectedIds, setSelectedIds, managedOnly }: Props) => {
	const { t } = useTranslation();
	const { organisationInfo, isAnyTeamAdmin } = useOrganisationInfo();
	const { data } = useGetOrganisationTeamsQuery({
		skip: !organisationInfo,
		variables: { uuid: organisationInfo?.uuid || '' },
	});

	if (!organisationInfo || (!isAnyTeamAdmin && organisationInfo.role !== OrganisationRole.Admin)) {
		return null;
	}

	if (!data?.organisation.teams.length) {
		return null;
	}

	const managedTeams = organisationInfo.teams.filter(
		(team) => team.role === OrganisationTeamRole.Admin,
	);
	const availableTeams = managedOnly
		? data.organisation.teams.filter((team) =>
				managedTeams.some((adminedTeam) => adminedTeam.uuid === team.uuid),
			)
		: data.organisation.teams;

	return (
		<View>
			<Text category="h5">{t('post.new.your-teams')}</Text>

			<ContactsSelect
				mode="multi"
				contacts={availableTeams}
				selectedIds={selectedIds}
				setSelectedIds={setSelectedIds}
			/>
		</View>
	);
};
